module.exports = __webpack_public_path__ + "static/media/CircularStd-MediumItalic.eddb7021.woff";